module.exports = __webpack_public_path__ + "static/media/eventsBW.81538aad.webp";